import React, { useEffect, useState } from "react";
import "../../Styles/latestpropert.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CiLocationOn } from "react-icons/ci";
import { useNavigate } from "react-router-dom";

const SampleNextArrow = (props) => {
  const { className, style, onClick } = props;
  return <div className={className} onClick={onClick} />;
};

const SamplePrevArrow = (props) => {
  const { className, style, onClick } = props;
  return <div className={className} onClick={onClick} />;
};

const LatestProperties = ({ latestProperty, rent, sell }) => {
  const navigate = useNavigate()
  const [activeBtn, setActiveBtn] = useState("all");
  const [data, setData] = useState(latestProperty);

  useEffect(() => {
    setData(latestProperty)
  }, [latestProperty])

  const settings = {
    dots: false,
    autoplay: false,
    autoplaySpeed: 3000,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <section className="latest-section">
        <div className="container">
          <div className="row">
            <div className="col-12 property-heading-col">
              <h3>Latest Properties</h3>

              <div className="latest_propert_btns">
                <button
                  onClick={() => {
                    setActiveBtn("all");
                    setData(latestProperty);
                  }}
                  className={`${activeBtn === "all"
                    ? "latest_propert_btn_active"
                    : "latest_propert_deactive_btn"
                    }`}
                >
                  All Properties
                </button>
                <button
                  onClick={() => {
                    setActiveBtn("rent");
                    setData(rent);
                  }}
                  className={`${activeBtn === "rent"
                    ? "latest_propert_btn_active"
                    : "latest_propert_deactive_btn"
                    }`}
                >
                  For Rent
                </button>
                <button
                  onClick={() => {
                    setActiveBtn("sell");
                    setData(sell);
                  }}
                  className={`${activeBtn === "sell"
                    ? "latest_propert_btn_active"
                    : "latest_propert_deactive_btn"
                    }`}
                >
                  For Sell
                </button>
              </div>
            </div>

            <Slider {...settings}>
              {data &&
                data?.map((item, i) => {
                  return (
                    <div key={i} className="col-md-4">
                      <div className="latest-property-box" onClick={() =>
                        navigate(`/property-details/${item.slug}-${item.id}`)
                      } style={{ cursor: 'pointer' }}>
                        <p className="latest_property_label">For {item.Type}</p>
                        <img
                          src={item.image || "/images/arizona.png"}
                          alt="Arizona"
                        />
                        <div className="latest-property-title">
                          <h5 className="truncate-title">{item.title}</h5>
                          <div className="d-flex align-items-center ">
                            <CiLocationOn />
                            <p>{item.address}</p>
                          </div>
                          <div className="latest_propert_btns">
                            <button className={"latest_propert_details"}>
                              {item.badroom} Beds
                            </button>
                            <button className={"latest_propert_details"}>
                              {item.bathroom} Baths
                            </button>
                            <button className={"latest_propert_details"}>
                              {item.area_sqft} Sqft
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </Slider>
          </div>
        </div>
      </section>
    </>
  );
};

export default LatestProperties;
